export const GET_DEPARTMENT_SERVICES_DATA="GET_DEPARTMENT_SERVICES_DATA";
export const GET_DEPARTMENT_SERVICES_SUCCESS="GET_DEPARTMENT_SERVICES_SUCCESS";
export const GET_DEPARTMENT_SERVICES="GET_DEPARTMENT_SERVICES";

export const GET_OT_GROUP="GET_OT_GROUP";
export const GET_OT_GROUP_DATA="GET_OT_GROUP_DATA";
export const GET_OT_GROUP_SUCCESS="GET_OT_GROUP_SUCCESS";

export const GET_SB_GROUP="GET_SB_GROUP";
export const GET_SB_GROUP_DATA="GET_SB_GROUP_DATA";
export const GET_SB_GROUP_SUCCESS="GET_SB_GROUP_SUCCESS";